<template>
    <div>
        <div class="field">
            <InputURL v-model="url" @input="emitValues" />
        </div>

        <div class="field">
            <p v-if="!customTitleActive" class="control">
                <label class="checkbox is-pulled-left">
                    <input v-model="customTitle" type="checkbox" />
                    {{ $t('creation.input_url_title') }}
                </label>
            </p>
        </div>
        <div class="field">
            <p class="control">
                <span
                    v-if="customTitleActive"
                    v-t="'creation.input_url_button_title'"
                    class="label has-text-grey mb-0 is-block"
                />
                <input
                    v-if="customTitle || customTitleActive"
                    v-model="title"
                    class="input mt-2"
                    type="text"
                    @change="emitValues"
                />
            </p>
        </div>
        <div v-if="customTitle && !customTitleActive" class="field">
            <div class="control">
                <div class="buttons is-centered">
                    <button class="lb-button is-primary mt-2">
                        {{ title }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputURL from '@/components/InputURL';
export default {
    components: {
        InputURL,
    },
    model: {
        prop: 'info',
    },
    props: {
        info: {
            type: Object,
            default() {
                return {
                    url: null,
                    title: null,
                };
            },
        },
        customTitleActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            url: this.info.url,
            title:
                this.info.title || this.$t('creation.url_button_placeholder'),
            customTitle: !!this.info.title || this.customTitleActive,
        };
    },
    methods: {
        emitValues() {
            this.$emit('input', {
                url: this.url,
                title: this.customTitle ? this.title : this.url,
            });
        },
    },
};
</script>

<style></style>
